/* eslint-disable */
const $ = require('jquery');

class Nav {

    constructor() {

        this.$body = $('body');

        // Mobile nav/drawer variables
        this.$mobileNav = $('.js-megamenu > a');

        this.events();
    }

    events() {
        // Mobile nav trigger
        this.$mobileNav.on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.showNav(e.currentTarget);
        });

        // Expand megamenu sections
        $('.megamenu__section h5').on('click', (e) => {
            console.log(e.currentTarget);
            if ($(e.currentTarget).parent('.megamenu__section').hasClass('megamenu__section--expanded')) {
                $(e.currentTarget).next('ul').slideToggle();
                $(e.currentTarget).parent('.megamenu__section').removeClass('megamenu__section--expanded');
            } else {
                this.expandSections(e.currentTarget);
            }
        });

        $('.js-megamenu-close').on('click', () => {
            this.hideNav();
        });
    }

    showNav(trigger) {
        if ($(trigger).closest('.js-megamenu').hasClass('megamenu--active')) {
            this.hideNav();
        } else {
            this.hideNav();
            $(trigger).closest('.js-megamenu').addClass('megamenu--active');
            this.$body.addClass('active-megamenu');
            $('.megamenu').scrollTop(0);
        }
    }

    hideNav() {
        $('.js-megamenu').removeClass('megamenu--active');
        this.$body.removeClass('active-megamenu');
    }

    expandSections(trigger) {
        if (this.$body.find('.megamenu__section--expanded')) {
            this.$body.find('.megamenu__section--expanded').children('ul').slideToggle();
            this.$body.find('.megamenu__section--expanded').removeClass('megamenu__section--expanded');
        }
        $(trigger).next('ul').slideToggle();
        $(trigger).parent('.megamenu__section').addClass('megamenu__section--expanded');
    }
}

export default new Nav();
